module.exports = __webpack_public_path__ + "img/u8431.f3165bb7.png";